















import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Prop} from 'vue-property-decorator';

@Component
export default class ScrollDownButton extends Vue {
    @Prop({required: false, default: 'fa-chevron-down'})
    icon!: string;

    @Prop({required: false, default: ''})
    label!: string;

    @Emit()
    clicked() {
       return;
    }
}

